import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../firebase-config";
import BaseChart from "./BaseChart";

export default function IncomeStatementAnalysis({
  periodIndex,
  id,
  years,
  period,
}) {
  // Income Statement
  const [revenue, setRevenue] = React.useState([]);
  const [pbt, setPbt] = React.useState([]);
  const [netIncome, setNetIncome] = React.useState([]);
  const [incomeYears, setIncomeYears] = React.useState([]);
  const [name, setName] = React.useState();

  // Loading State
  const [incomeLoading, setIncomeLoading] = React.useState(true);

  async function fetchIncomeStatements({ id, period, periodIndex, years }) {
    setIncomeLoading(true);
    const q = query(
      collection(db, "companies-financials"),
      where("company-id", "==", id),
      where("year", "in", years),
      where("type", "==", "Income Statement"),
      where("period", "==", period),
      where("period-index", "==", periodIndex)
    );
    const allDocs = [];
    const totalRev = [];
    const dataYears = [];
    const allPbt = [];
    const allNetIncome = [];
    let companyName;

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      allDocs.push(doc.data());
      companyName = doc.data()["name"];
    });

    allDocs.sort((a, b) => a["year"] - b["year"]);

    allDocs.forEach((doc) => {
      totalRev.push(doc["Total Revenue"]);
      dataYears.push(doc["year"]);
      allPbt.push(doc["PBT"]);
      allNetIncome.push(doc["Net Income"]);
    });

    setRevenue(totalRev);
    setIncomeYears(dataYears);
    setPbt(allPbt);
    setNetIncome(allNetIncome);
    setName(companyName);
    setIncomeLoading(false);
  }

  React.useEffect(() => {
    fetchIncomeStatements({
      id: id,
      period: period,
      periodIndex: periodIndex,
      years: years,
    });
  }, [years, id, period, periodIndex]);

  return incomeLoading ? (
    <h4>Loading</h4>
  ) : (
    <>
      <Typography variant="h5" align="center">
        {name}
      </Typography>
      <Typography variant="h5" align="center">
        Income Statement Trend
      </Typography>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <BaseChart
              name="Total Revenue"
              data={revenue}
              categories={incomeYears}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <BaseChart
              name="Profit Before Taxes"
              data={pbt}
              categories={incomeYears}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <BaseChart
              name="Net Income"
              data={netIncome}
              categories={incomeYears}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
